/* eslint-disable camelcase */
export function formatViewModelForEvent(data) {
    const { itemNumber, name, childReportingCategory, parentReportingCategory, selectedProduct } = data;

    const isSmartPak = selectedProduct && selectedProduct.isSmartPak;
    const isAutoShip = selectedProduct && selectedProduct.isAutoShip;
    const price = selectedProduct ? selectedProduct.price.current : data.price.current;
    const id = selectedProduct ? selectedProduct.id.toString() : '';
    const quantity = selectedProduct && data.type !== 'tes' ? selectedProduct.quantity : data.quantity;

    const convertToYesNo = value => typeof value === 'boolean' ? value ? 'yes' : 'no' : 'no';

    return {
        item_name: name,
        item_id: itemNumber.toString(),
        item_variant: id,
        item_parent_reporting_category: parentReportingCategory,
        item_child_reporting_category: childReportingCategory,
        item_autoship: convertToYesNo(isAutoShip),
        item_smartpak: convertToYesNo(isSmartPak),
        price: parseFloat(price.replace('$', '')).toFixed(2),
        quantity: quantity.toString()
    };
}